import $api from 'http'
import $apiJSON from 'http/apiJSON'

export async function createNewUser(
  first_name,
  last_name,
  middle_name,
  number_phone,
  inn,
  password,
  is_personal_kyrgyzkomur,
  position,
  department_id,
) {
  return $apiJSON.post('/account/register/', {
    first_name,
    last_name,
    middle_name,
    number_phone,
    inn,
    password,
    is_personal_kyrgyzkomur,
    position,
    department_id,
  })
}

export async function getTopPositionData(data) {
  return $api.get(`/position-empl/`, data)
}

export async function getPositionEmpData(id, data) {
  return $api.get(`/posempl/${id}/`, data)
}

export async function getOrganization(data) {
  return $api.get(`/organizations/admin-organizations/`, data)
}

export async function getAllCommand(data) {
  return $api.get(`/employees/admin-allcomands/`, data)
}

export async function checkINN(inn) {
  return $apiJSON.post('/employees/check-inn/', { inn })
}

export async function getDepartments() {
  return $api.get('/movement/departments/')
}

export async function createDepartment(name, description) {
  return $apiJSON.post('/movement/departments/', { name, description })
}

export async function deleteDepartment(id) {
  return $api.delete(`/movement/departments/${id}/`)
}

export async function getDepartmentDetail(id) {
  return $api.get(`/movement/departments/${id}/`)
}

export async function addEmployeesToDepartment(deptId, employeeIds) {
  return $apiJSON.post(`/movement/departments/${deptId}/members/`, { employee_ids: employeeIds })
}

export async function removeEmployeeFromDepartment(deptId, employeeId) {
  return $apiJSON.delete(`/movement/departments/${deptId}/members/`, { employee_id: employeeId })
}

export async function getPersonalEmployees() {
  return $api.get('/movement/personal-employees/')
}

export async function toggleEmployeeActive(employeeId) {
  return $apiJSON.patch(`/movement/employees/${employeeId}/toggle-active/`)
}

export async function changeEmployeeDept(employeeId, departmentId) {
  return $apiJSON.post(`/movement/employees/${employeeId}/change-dept/`, { department_id: departmentId })
}
